import React from "react";

const FilterAllocation = ({ title, percentageAmout, textColor, barcolor }) => {
  return (
    <div className="filter_allocation_main">
      <h2
        className={`${textColor === "white" ? "white_text" : "blueTextColor"} `}
      >
        {title}{" "}
        <span
          style={{
            color: barcolor,
          }}
        >
          {percentageAmout}
        </span>
      </h2>
      <div
        className={
          textColor === "white"
            ? "alloc_perc_bar infinity_back"
            : "alloc_perc_bar"
        }
      >
        <span
          style={{
            width: percentageAmout,
            borderColor: barcolor,
            backgroundColor: barcolor,
          }}
        ></span>
      </div>
    </div>
  );
};

export default FilterAllocation;
